// @flow

// Types
import type {
  Comment,
} from 'hfty-model-comments/types'

import {
  PROP_FIELD,
} from 'hfty-model-comments'

// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'

// Selectors
import { comments$ } from 'hfty-comments'
import commentField$ from './commentField'

export default createSelector(
  [comments$, commentField$],
  function (comments: Array<Comment>, fieldId: ?number): Array<Comment> {
    return _filter(comments, function (comment: Comment): boolean {
      return fieldId && comment[PROP_FIELD] === fieldId
    })
  }
)
